import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--left",
  "use": "icon-arrow--left-usage",
  "viewBox": "0 0 8 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 11\" id=\"icon-arrow--left\"><path d=\"M7.938 10.5H4.41L0 5.25 4.41 0h3.528l-4.41 5.25 4.41 5.25Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol